const styles = theme => ({
    root: {
        minHeight: '300px',
        width: '700px',
        paddingTop: '20px',
    },
    uploadFileItem: {
        padding: '8px',
    },
    fileInfo: {
        fontFamily: "AvenirNext",
        fontWeight: "500",
        fontStyle: "normal",
        letterSpacing: 0,
        color: "#4a4a4a",
    },
    uploadedFileName: {
        overflow: 'hidden',
        textOverflow: "ellipsis",
        width: '100%'
    },
})
export default styles;


